module.exports = __webpack_public_path__ + "fonts/nanumbarungothicbold-webfont.2aab3138.woff2";